import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import NewsSiderTitle from '../../../../components/newsSiderTitle';

class JpTitle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { nav },
        } = this.props;

        const len = nav.length - 1;

        return (
            <div>
                <NewsSiderTitle type={1} content={nav.slice(0, len)}>
                    <a className={styles.jp} href={nav[len].url} target="_blank">
                        {nav[len].title}
                    </a>
                </NewsSiderTitle>
            </div>
        );
    }
}

export default errorBoundary(JpTitle);
